import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3a5a1c9b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a1c9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5a1c9b')) {
      api.createRecord('3a5a1c9b', component.options)
    } else {
      api.reload('3a5a1c9b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3a5a1c9b&scoped=true&", function () {
      api.rerender('3a5a1c9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/rule/ruleFactor/index.vue"
export default component.exports